import { Routes as Switch, Route, Navigate } from 'react-router-dom';
import { Login } from '../pages/Login/Login';
import { Register } from '../pages/Register/Register';
import { ResetPassword } from '../pages/ResetPassword/ResetPassword';
import { PrivateRoute } from '../components/PrivateRoute/PrivateRoute';
import { Profile } from '../pages/Profile/Profile';
import { AddActivity } from '../pages/AddActivity/AddActivity';
import { APP_PATHS } from '../constants/paths';
import { Community } from '../pages/Community/Community';
import { Post } from '../pages/Post/Post';
import { ProtectedRoute } from '../components/ProtectedRoute/ProtectedRoute';
import { Videos } from '../pages/Videos/Videos';
import { Coach } from '../pages/Coach/Coach';
import { CoachResponse } from '../pages/CoachResponse/CoachResponse';
import { Admin } from '../pages/Admin/Admin';
import { Challenge } from '../pages/Challenge/Challenge';
import { SignUpHolding } from '../pages/SignUpHolding/SignUpHolding';
import { HoldingRoute } from '../components/HoldingRoute/HoldingRoute';
import { AddVideo } from '../pages/AddVideo/AddVideo';

export const Routes = () => (
  <Switch>
    <Route element={<ProtectedRoute />}>
      <Route path="/" element={<Navigate to={APP_PATHS.login} />} />
      <Route path={APP_PATHS.register} element={<Register />} />
      <Route path={APP_PATHS.login} element={<Login />} />
      <Route path={APP_PATHS.resetPassword} element={<ResetPassword />} />
    </Route>

    <Route element={<HoldingRoute />}>
      <Route path={APP_PATHS.signUp} element={<SignUpHolding />} />
    </Route>

    <Route element={<PrivateRoute />}>
      <Route path={APP_PATHS.profile} element={<Profile />} />
      <Route path={APP_PATHS.community} element={<Community />} />
      <Route path={APP_PATHS.addActivity} element={<AddActivity />} />
      <Route path={APP_PATHS.post} element={<Post />} />
      <Route path={APP_PATHS.videos} element={<Videos />} />
      <Route path={APP_PATHS.addVideo} element={<AddVideo />} />
      <Route path={APP_PATHS.coach} element={<Coach />} />
      <Route path={APP_PATHS.coachResponse} element={<CoachResponse />} />
      <Route path={APP_PATHS.admin} element={<Admin />} />
      <Route path={APP_PATHS.challenge} element={<Challenge />} />
    </Route>

    <Route path="*" element={<Navigate to={APP_PATHS.home} replace />} />
  </Switch>
);
